import { MerchantEvents } from "./events";

/**
 * Maps live event names → growth taxonomy IDs (Untitled growth data doc).
 * Prefer props over renaming events once they are in production.
 */
export const MERCHANT_EVENT_TAXONOMY: Record<string, string> = {
  // U1 — signed up / auth
  [MerchantEvents.LOGIN_SCREEN]: "U1",
  [MerchantEvents.LOGIN_SUCCESS]: "U1",
  [MerchantEvents.LOGIN_SUCCESS_EMAIL_REDIRECT]: "U1",
  [MerchantEvents.LOGIN_SUCCESS_GOOGLE_REDIRECT]: "U1",
  [MerchantEvents.LOGIN_FAILED]: "U1",
  [MerchantEvents.GOOGLE_SIGN_IN_CLICKED]: "U1",
  [MerchantEvents.GOOGLE_COMPLETE_PROFILE_SCREEN]: "U1",
  [MerchantEvents.GOOGLE_COMPLETE_PROFILE_SUBMITTED]: "U1",
  [MerchantEvents.INVITE_USER_SCREEN]: "U1",
  [MerchantEvents.ACCOUNT_ONBOARD_SCREEN]: "U1",
  [MerchantEvents.ONBOARDING_STARTED]: "U1",
  [MerchantEvents.ONBOARDING_COMPLETED]: "U1",

  // U2 — KYB
  [MerchantEvents.KYB_STEP_VIEWED]: "U2",
  [MerchantEvents.KYB_STEP_SUBMITTED]: "U2",
  [MerchantEvents.KYB_API_ERROR]: "U2",
  [MerchantEvents.KYB_DOCUMENT_UPLOAD_REJECTED]: "U2",
  [MerchantEvents.KYB_OCR_EXTRACTION_FAILED]: "U2",
  [MerchantEvents.ONBOARDING_STEP_VIEWED]: "U2",
  [MerchantEvents.COMPLETE_REGISTRATION_VIEW]: "U2",

  // U3 — approved / live
  [MerchantEvents.KYB_COMPLETED]: "U3",

  // M1 — arrived
  [MerchantEvents.HOME]: "M1",
  [MerchantEvents.SANDBOX_HOME]: "M1",

  // M2 — browsed
  [MerchantEvents.INVOICES_LIST]: "M2",
  [MerchantEvents.SUBSCRIPTIONS_LIST]: "M2",
  [MerchantEvents.PAYMENT_LINKS_LIST]: "M2",
  [MerchantEvents.PRODUCTS_LIST]: "M2",
  [MerchantEvents.CUSTOMERS_LIST]: "M2",
  [MerchantEvents.SETTLEMENT_VIEW]: "M2",
  [MerchantEvents.SETTINGS]: "M2",

  // M3 — clicked (high-signal only; not every click)
  [MerchantEvents.ADD_PRODUCT_CLICKED]: "M3",
  [MerchantEvents.ADD_CUSTOMER_CLICKED]: "M3",
  [MerchantEvents.ADD_PRICING_TABLE_CLICKED]: "M3",
  [MerchantEvents.INVOICE_MODAL_OPEN]: "M3",
  [MerchantEvents.PAYMENT_LINK_MODAL_OPEN]: "M3",
  [MerchantEvents.SUBSCRIPTION_MODAL_OPEN]: "M3",

  // M4 — searched
  [MerchantEvents.SEARCH_INVOICES]: "M4",
  [MerchantEvents.SEARCH_SUBSCRIPTIONS]: "M4",
  [MerchantEvents.SEARCH_PAYMENT_LINKS]: "M4",
  [MerchantEvents.SEARCH_PRODUCTS]: "M4",
  [MerchantEvents.SEARCH_CUSTOMERS]: "M4",
  [MerchantEvents.SEARCH_SETTLEMENTS]: "M4",
  [MerchantEvents.FILTER_INVOICES]: "M4",
  [MerchantEvents.FILTER_SUBSCRIPTIONS]: "M4",

  // M5 — did a task
  [MerchantEvents.INVOICE_CREATE_INITIATED]: "M5",
  [MerchantEvents.INVOICE_CREATED]: "M5",
  [MerchantEvents.PAYMENT_LINK_CREATE_INITIATED]: "M5",
  [MerchantEvents.PAYMENT_LINK_CREATED]: "M5",
  [MerchantEvents.SUBSCRIPTION_CREATE_INITIATED]: "M5",
  [MerchantEvents.SUBSCRIPTION_CREATED]: "M5",
  [MerchantEvents.PRODUCT_CREATE_INITIATED]: "M5",
  [MerchantEvents.PRODUCT_CREATED]: "M5",
  [MerchantEvents.CUSTOMER_CREATE_INITIATED]: "M5",
  [MerchantEvents.CUSTOMER_CREATED]: "M5",
  [MerchantEvents.DOWNLOAD_CSV]: "M5",
  [MerchantEvents.DOWNLOAD_XLS]: "M5",

  // M6 — edited
  [MerchantEvents.PAYMENT_LINK_UPDATED]: "M6",
  [MerchantEvents.PAYMENT_LINK_DEACTIVATED]: "M6",
  [MerchantEvents.SUBSCRIPTION_CANCELLED]: "M6",
  [MerchantEvents.PRODUCT_UPDATED]: "M6",
  [MerchantEvents.PRODUCT_DELETED]: "M6",
  [MerchantEvents.INVOICES_BULK_UPDATE]: "M6",
  [MerchantEvents.CANCEL_INVOICE]: "M6",
  [MerchantEvents.CANCEL_INVOICE_SUCCESS]: "M6",

  // M7 — set up
  [MerchantEvents.SETTINGS_INVITE_USER_SUCCESS]: "M7",
  [MerchantEvents.SETTINGS_BRANCHES_SAVE]: "M7",
  [MerchantEvents.SETTINGS_BANK_ADDED]: "M7",
  [MerchantEvents.SETTINGS_BANK_UPDATED]: "M7",
  [MerchantEvents.SETTINGS_CREATE_API_KEY]: "M7",
  [MerchantEvents.SETTINGS_CREATE_WEBHOOK]: "M7",
  [MerchantEvents.SETTINGS_PAYMENT_METHOD_TOGGLED]: "M7",
  [MerchantEvents.SETTINGS_REFUND_POLICY_UPDATED]: "M7",

  // M9 — got stuck
  [MerchantEvents.ONBOARDING_FORM_VALIDATION_ERROR]: "M9",
  [MerchantEvents.ONBOARDING_API_ERROR]: "M9",
  [MerchantEvents.INVOICE_CREATE_FAILED]: "M9",
  [MerchantEvents.PAYMENT_LINK_CREATE_FAILED]: "M9",
  [MerchantEvents.SUBSCRIPTION_CREATE_FAILED]: "M9",
  [MerchantEvents.MARK_AS_PAID_FAILED]: "M9",
  [MerchantEvents.REFUND_FAILED]: "M9",
  [MerchantEvents.CANCEL_INVOICE_FAILED]: "M9",
  [MerchantEvents.SETTINGS_BRANCHES_ERROR]: "M9",
  [MerchantEvents.SETTINGS_BANK_ERROR]: "M9",
  [MerchantEvents.SETTINGS_CREATE_API_KEY_ERROR]: "M9",
  [MerchantEvents.SETTINGS_CREATE_WEBHOOK_ERROR]: "M9",

  // M10 — asked
  [MerchantEvents.HOME_ANALYTICS_HELP_CLOSED]: "M10",
  [MerchantEvents.KYB_CONTACT_SALES_CLICKED]: "M10",

  // P6 offline / P8 refunds from merchant side
  [MerchantEvents.MARK_AS_PAID]: "P6",
  [MerchantEvents.REFUND_SUCCESS]: "P8",
  [MerchantEvents.REFUND_PAYMENT]: "P8",
};
